import { render } from "./AddPlantDashboardPosition.vue?vue&type=template&id=19fe2d25"
import script from "./AddPlantDashboardPosition.vue?vue&type=script&lang=js"
export * from "./AddPlantDashboardPosition.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__